const router = function (permissions) {
  return ({
    path: 'fornecedores',
    component: () => import('@/views/Fornecedor/FornecedorModule.vue'),
    meta: { permissions },
    children: [
      {
        path: '/',
        component: () => import('@/views/Fornecedor/FornecedorList.vue'),
        meta: { permissions, title: 'Manutenção de Empresas' },
      },
      {
        path: 'cadastrar',
        component: () => import('@/views/Fornecedor/FornecedorProfile.vue'),
        meta: { permissions, title: 'Cadastrando Empresa' },
      },
      {
        path: 'alterar',
        component: () => import('@/views/Fornecedor/FornecedorProfile.vue'),
        meta: { permissions, title: 'Editando Empresa' },
      },
    ],
  })
}

export default {
  router,
}
